import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStore, faStream, faMobileAlt } from '@fortawesome/free-solid-svg-icons'

const STEPS = [
  {
    icon: faStore,
    tone: 'orange',
    title: 'Você cuida do veículo normalmente',
    text: 'A oficina registra o atendimento normalmente pelo sistema que já usa.',
  },
  {
    icon: faStream,
    tone: 'amber',
    title: 'O atendimento entra no histórico',
    text: 'Serviços, peças, quilometragem e valores ficam organizados em um único lugar.',
  },
  {
    icon: faMobileAlt,
    tone: 'teal',
    title: 'O cliente acompanha pelo celular',
    text: 'Mais segurança para cuidar, vender e lembrar do que o seu veículo precisa.',
  },
]

export default function HowItWorks() {
  return (
    <section id='como-funciona' className='home-section home-how' aria-labelledby='home-how-title'>
      <header className='home-section-header'>
        <span className='home-eyebrow'>Como funciona</span>
        <h2 id='home-how-title'>Sem cadastro manual. O histórico se monta sozinho.</h2>
      </header>
      <ol className='home-steps'>
        {STEPS.map((step, index) => (
          <li key={step.title} className='home-step'>
            <span className='home-step-number' aria-hidden='true'>{index + 1}</span>
            <span className={`home-icon home-icon-${step.tone} home-step-icon`} aria-hidden='true'>
              <FontAwesomeIcon icon={step.icon} />
            </span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </li>
        ))}
      </ol>
    </section>
  )
}
